/* EdenColor — blog : barre de lecture et défilement doux du sommaire.
   Rien d'indispensable ici : sans JavaScript, l'article et le sommaire marchent. */
(function () {
  var bar = document.querySelector('[data-ecb-progress]');
  var body = document.querySelector('[data-ecb-body]');
  // décalage sous le menu collant du thème (Horizon expose --header-height)
  var headerH = function () { return (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 80) + 24; };

  if (bar && body) {
    var ticking = false;
    var update = function () {
      var r = body.getBoundingClientRect();
      var total = r.height - window.innerHeight * 0.6;
      var p = Math.max(0, Math.min(1, -r.top / Math.max(total, 1)));
      bar.style.width = (p * 100).toFixed(2) + '%';
      ticking = false;
    };
    // capture : attrape aussi le défilement d'un conteneur du thème, pas seulement de la fenêtre
    document.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true, capture: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('.ecb-toc a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var el = document.getElementById(decodeURIComponent(a.getAttribute('href').slice(1)));
      if (!el) return;
      e.preventDefault();
      // scrollIntoView suit le conteneur qui défile réellement (Horizon ne fait pas toujours défiler la fenêtre) ;
      // le décalage sous le menu vient de scroll-margin-top, posé en CSS sur les h2.
      el.style.scrollMarginTop = headerH() + 'px';
      el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      history.replaceState(null, '', a.getAttribute('href'));
    });
  });

  // Tableaux trop larges pour l'écran (mobile surtout) : une ombre à droite dit
  // qu'il reste des colonnes, et « Faites glisser → » s'affiche au-dessus (CSS :
  // mobile seulement). L'ombre disparaît quand on arrive au bout du tableau.
  document.querySelectorAll('.ecb-table-wrap').forEach(function (wrap) {
    var box = document.createElement('div');
    box.className = 'ecb-table-box';
    wrap.parentNode.insertBefore(box, wrap);
    var hint = document.createElement('p');
    hint.className = 'ecb-table-hint';
    hint.setAttribute('aria-hidden', 'true');
    hint.textContent = 'Faites glisser \u2192';
    box.parentNode.insertBefore(hint, box);
    box.appendChild(wrap);
    var check = function () {
      var over = wrap.scrollWidth > wrap.clientWidth + 2;
      box.classList.toggle('is-overflow', over);
      hint.classList.toggle('is-on', over);
      box.classList.toggle('is-end', !over || wrap.scrollLeft + wrap.clientWidth >= wrap.scrollWidth - 2);
    };
    wrap.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check, { passive: true });
    check();
  });
})();
